<div class="w3-container w3-light-grey">
    <h1>Créer Article</h1>
    <button class=" text-white btnPrev" data-toggle="modal" data-target="#myModal">Prévisualiser</button>
    <button class="item btnsp" style="margin-left: 3%;" data-toggle="modal"
        data-target="#exampleModalLong">Sauvegarde</button>
    <!-- Button trigger modal -->
    <hr>
    <div class="row">
        <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12" *ngIf="Docu">
            <section class="sectionParagraphe">
                <p>Titre</p>
                <angular-editor id="tit" [placeholder]="'Saisissez le titre'" [(ngModel)]="titre"
                    [config]="configtitre">
                </angular-editor>
                <div id="accordion">
                    <div class="card">
                        <div class="card-header" style="padding: 0%;" id="headingTwo2">
                            <h5 class="mb-0">
                                <button class="btn btn-link collapsed" data-toggle="collapse"
                                    data-target="#collapseTwo2" aria-expanded="false" aria-controls="collapseTwo2">
                                    <img src="assets/images/uk.jpg" title="Texte en anglais" alt="UK flag" width="30px"
                                        height="20px" />
                                </button>
                            </h5>
                        </div>
                        <div id="collapseTwo2" class="collapse" aria-labelledby="headingTwo2" data-parent="#accordion">
                            <div class="card-body">
                                <angular-editor id="titreEnglish" [(ngModel)]="titreEN" [config]="config" name="titre"
                                    [placeholder]="'Titre en anglais'" required="required">
                                </angular-editor>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="sectionParagraphe">
                <p>Résumé</p>
                <angular-editor id="msg" [placeholder]="'Saisissez le Résumé'" [(ngModel)]="resume" [config]="config">
                </angular-editor>
                <div id="accordion">
                    <div class="card">
                        <div class="card-header" style="padding: 0%;" id="headingTwo1">
                            <h5 class="mb-0">
                                <button class="btn btn-link collapsed" data-toggle="collapse"
                                    data-target="#collapseTwo1" aria-expanded="false" aria-controls="collapseTwo1">
                                    <img src="assets/images/uk.jpg" title="Texte en anglais" alt="UK flag" width="30px"
                                        height="20px" />
                                </button>
                            </h5>
                        </div>
                        <div id="collapseTwo1" class="collapse" aria-labelledby="headingTwo1" data-parent="#accordion">
                            <div class="card-body">
                                <angular-editor id="resumeEnglish" [(ngModel)]="resumeEN" [config]="config"
                                    name="resume" [placeholder]="'Résumé en anglais'" required="required">
                                </angular-editor>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <br />
            <div>
                <div class="elmLeft"></div>
                <div class="elmRight" *ngIf="paragraphes.length > 1">
                    <div class="form-group">
                        <fa-icon [icon]="faList" class="fa-2x" data-toggle="modal" title="Ranger" data-target="#order"
                            style="color: #1158a1; margin-top: 10px;">
                        </fa-icon>
                    </div>
                </div>
            </div>
            <br />
            <section class="sectionParagraphe" *ngFor="let paragraphe of paragraphes; let i = index;">
                <button type="button" (click)="removeParagraphe(i)" class="btnclose">
                    <span aria-hidden="true">&times;</span>
                </button>
                Paragraphe {{i+1}}
                <p></p>
                <angular-editor id="sousTitreParagraphe" [placeholder]="'Saisissez le sous titre'"
                    [(ngModel)]="paragraphe.titre" [config]="configtitre" name="titre_{{i}}"></angular-editor>
                <div class="card">
                    <div class="card-header" style="padding: 0%;" id="PartitreId{{i+1}}">
                        <h5 class="mb-0">
                            <button class="btn btn-link collapsed" data-toggle="collapse"
                                attr.data-target="#collapseParTitre{{i+1}}" aria-expanded="false"
                                attr.aria-controls="collapseParTitre{{i+1}}">
                                <img src="assets/images/uk.jpg" title="Texte en anglais" alt="UK flag" width="30px"
                                    height="20px" />
                            </button>
                        </h5>
                    </div>
                    <div id="collapseParTitre{{i+1}}" class="collapse" attr.aria-labelledby="PartitreId{{i+1}}"
                        data-parent="#accordion">
                        <div class="card-body">
                            <angular-editor id="titparEn{{i+1}}" [placeholder]="'Titre en anglais'"
                                [(ngModel)]="paragraphe.titreEN" [config]="configtitre">
                            </angular-editor>
                        </div>
                    </div>
                </div>
                <angular-editor id="msg" [(ngModel)]="paragraphe.body" [config]="config" name="body{{i}}"
                    required="required"></angular-editor>
                <div class="card">
                    <div class="card-header" style="padding: 0%;" id="ParBodyId{{i+1}}">
                        <h5 class="mb-0">
                            <button class="btn btn-link collapsed" data-toggle="collapse"
                                attr.data-target="#collapseParBody{{i+1}}" aria-expanded="false"
                                attr.aria-controls="collapseParBody{{i+1}}">
                                <img src="assets/images/uk.jpg" title="Texte en anglais" alt="UK flag" width="30px"
                                    height="20px" />
                            </button>
                        </h5>
                    </div>
                    <div id="collapseParBody{{i+1}}" class="collapse" attr.aria-labelledby="ParBodyId{{i+1}}"
                        data-parent="#accordion">
                        <div class="card-body">
                            <angular-editor id="bodyEn{{i+1}}" [placeholder]="'Texte en anglais'"
                                [(ngModel)]="paragraphe.bodyEN" [config]="configtitre">
                            </angular-editor>
                        </div>
                    </div>
                </div>
                <br />
            </section>
            <br />
            <button class="item btnsp" style="width: auto; height: 35px;" (click)="AddParagraphe()"> Ajouter une
                Paragraphe
            </button>
            <br />
            <br />
            <mat-checkbox color='primary' (change)="getLink()" [(ngModel)]="lien" name="lien">Fournir un lien de
                l'article
            </mat-checkbox>
            <p></p>
            <mat-checkbox color='primary' (change)="changeEtat()" [(ngModel)]="estPublie" name="estPublie">
                Publication de l'article
            </mat-checkbox>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12" *ngIf="!Docu">
            <!--<section class="sectionParagraphe">
                <p>Description</p>
                <angular-editor id="msg" [(ngModel)]="description" [config]="config" name="description"
                    required="required">
                </angular-editor>
            </section>
            <section class="sectionParagraphe">
                <p>Résumé</p>
                <angular-editor id="msg" [placeholder]="'Saisissez le Résumé'" [(ngModel)]="resume" [config]="config">
                </angular-editor>
            </section>-->
            <section class="sectionParagraphe">
                <p>Mots clés</p>
                <mat-form-field style="position: absolute;display: contents; border: solid 1px;">
                    <mat-chip-list #chipList aria-label="Fruit selection">
                        <div style="display: inline-block ; width: 100%;">
                            <mat-chip *ngFor="let tl of mc" [selectable]="selectable" [removable]="removable"
                                (removed)="remove(tl)">
                                {{tl.name}}
                                <mat-icon matChipRemove *ngIf="removable">&times;</mat-icon>
                            </mat-chip>
                        </div>

                        <input class="form-control" type="text" [matChipInputFor]="chipList"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                            (matChipInputTokenEnd)="add($event)" style="height: 40px; width: 100%; border: solid 1px;">
                    </mat-chip-list>
                </mat-form-field>
                <br />
                Mots clés en anglais
                <mat-form-field style="position: absolute;display: contents; border: solid 1px;">
                    <mat-chip-list #chipListEN aria-label="Fruit selection">
                        <div style="display: inline-block ; width: 100%;">
                            <mat-chip *ngFor="let tlEN of mcEN" [selectable]="selectable" [removable]="removable"
                                (removed)="removeEN(tlEN)">
                                {{tlEN.name}}
                                <mat-icon matChipRemove *ngIf="removable">&times;</mat-icon>
                            </mat-chip>
                        </div>
                        <input class="form-control" type="text" [matChipInputFor]="chipListEN"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                            (matChipInputTokenEnd)="addEN($event)"
                            style="height: 40px; width: 100%; border: solid 1px;">
                    </mat-chip-list>
                </mat-form-field>
            </section>
            <section class="sectionParagraphe">
                <p>tag</p>
                <mat-form-field style="position: absolute;display: contents; border: solid 1px;">
                    <mat-chip-list #chipList2 aria-label="Fruit selection">
                        <div style="display: inline-block ; width: 100%;">
                            <mat-chip *ngFor="let tg of tags" [selectable]="selectable" [removable]="removable"
                                (removed)="removeTags(tg)">
                                {{tg.name}}
                                <mat-icon matChipRemove *ngIf="removable">&times;</mat-icon>
                            </mat-chip>
                        </div>

                        <input class="form-control" type="text" [matChipInputFor]="chipList2"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                            (matChipInputTokenEnd)="addTags($event)"
                            style="height: 40px; width: 100%; border: solid 1px;">
                    </mat-chip-list>
                </mat-form-field>
                <br />
                tag en anglais
                <mat-form-field style="position: absolute;display: contents; border: solid 1px;">
                    <mat-chip-list #chipList2EN aria-label="Fruit selection">
                        <div style="display: inline-block ; width: 100%;">
                            <mat-chip *ngFor="let tgEN of tagsEN" [selectable]="selectable" [removable]="removable"
                                (removed)="removeTagsEN(tgEN)">
                                {{tgEN.name}}
                                <mat-icon matChipRemove *ngIf="removable">&times;</mat-icon>
                            </mat-chip>
                        </div>

                        <input class="form-control" type="text" [matChipInputFor]="chipList2EN"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                            (matChipInputTokenEnd)="addTagsEN($event)"
                            style="height: 40px; width: 100%; border: solid 1px;">
                    </mat-chip-list>
                </mat-form-field>
            </section>
            <br />
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
            <div class="card">
                <div class="card-header text-center">
                    <ul class="nav nav-tabs card-header-tabs">
                        <li class="nav-item">
                            <a [href]="" class="nav-link active" *ngIf="Docu">Document</a>
                            <a  [href]="" class="nav-link" (click)="setDialog(true)" *ngIf="!Docu">Document</a>
                        </li>
                        <li class="nav-item">
                            <a [href]="" class="nav-link active" *ngIf="!Docu">Paramètres</a>
                            <a [href]="" class="nav-link" (click)="setDialog(false)" *ngIf="Docu">Paramètres</a>
                        </li>
                    </ul>
                </div>
                <div class="card-body" *ngIf="Docu">
                    <div id="accordion">
                        <!--<div class="card">
                            <div class="card-header" id="headingOne">
                                <h5 class="mb-0">
                                    <button class="btn btn-link collapsed" data-toggle="collapse"
                                        data-target="#collapseOne" aria-expanded="false"
                                        aria-controls="collapseOne">
                                        MISE EN PAGE
                                    </button>
                                </h5>
                            </div>
                            <div id="collapseOne" class="collapse" aria-labelledby="headingOne"
                                data-parent="#accordion">
                                <div class="card-body">
                                    <p>Modèles</p>
                                    <select [(ngModel)]="modeles" name="modeles" class="listBlue">
                                        <option class="list" value="">
                                            Test</option>
                                    </select><br />
                                    <p>Polices</p>
                                    <select [(ngModel)]="polices" name="polices" class="listBlue">
                                        <option class="list" style="font-family: 'Segoe UI';" value="">Segoe UI
                                        </option>
                                        <option class="list" style="font-family: Arial;" value="">Arial</option>
                                        <option class="list" style="font-family: Georgia;" value="">Georgia</option>
                                        <option class="list" style="font-family: Impact;" value="">Impact</option>
                                        <option class="list" style="font-family: Tahoma;" value="">Tahoma</option>
                                        <option class="list" style="font-family: 'Times New Roman';" value="">Times
                                            New Roman</option>
                                        <option class="list" style="font-family: Verdana;" value="">Verdana</option>
                                    </select><br />
                                    <hr />
                                    <p>Taille de la police</p>
                                    <div style="display: flex;">
                                        <input type="range" [(ngModel)]="taillePolice" name="taillePolice"
                                            value="20" min="8" max="40">
                                        <input type="number" [(ngModel)]="taillePolice" name="taillePolice" min="8"
                                            max="40" style="width : 40px;">
                                    </div>
                                    <hr />

                                    <hr />
                                    <p>Balise Entête</p>
                                    <select [(ngModel)]="baliseEntete" name="baliseEntete" class="listBlue">
                                        <option value="p">Paragraphe</option>
                                        <option value="h1">
                                            <h1>H1</h1>
                                        </option>
                                        <option value="h2">
                                            <h2>H2</h2>
                                        </option>
                                        <option value="h3">
                                            <h3>H3</h3>
                                        </option>
                                        <option value="h4">H4</option>
                                        <option value="h5">H5</option>
                                        <option value="h6">
                                            <h6>H6</h6>
                                        </option>
                                    </select><br />
                                </div>
                            </div>
                        </div>-->
                        <div class="card">
                            <div class="card-header" id="headingFour2">
                                <h5 class="mb-0">
                                    <button class="btn btn-link collapsed" data-toggle="collapse"
                                        data-target="#collapseFour2" aria-expanded="false"
                                        aria-controls="collapseFour2">
                                        Etat
                                    </button>
                                </h5>
                            </div>
                            <div id="collapseFour2" class="collapse" aria-labelledby="headingFour2"
                                data-parent="#accordion">
                                <div class="card-body">
                                    <select class="listBlue" [(ngModel)]="etat" name="etat">
                                        <option value="Brouillon">Brouillon</option>
                                        <option value="Publie">Publié</option>
                                        <option value="Prive">Privé</option>
                                        <option value="EnAttenteDeLecture">En attente de lecture</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="headingThree">
                                <h5 class="mb-0">
                                    <button class="btn btn-link collapsed" data-toggle="collapse"
                                        data-target="#collapseThree" aria-expanded="false"
                                        aria-controls="collapseThree">
                                        Album photo
                                    </button>
                                </h5>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                                data-parent="#accordion">
                                <div class="card-body">
                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr *ngFor="let file of fileToUpload; let j = index;">
                                                <td>
                                                    <button type="button" class="btnFermer" (click)="removeFile(file)">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                    {{file.name}}
                                                    <br />
                                                    <br />
                                                    <input class="page" type="text" [(ngModel)]="file.alt" name="BaliseAlt"
                                                    placeholder="Balise ALT "><br />
                                                <input class="page" type="text" [(ngModel)]="file.altEN"
                                                    name="BaliseAltEN" placeholder="Balise ALT en anglais"><br />
                                                    <br />
                                                    <input type="checkbox" [(ngModel)]="file.IsBackground"
                                                        name="IsBackground_{{j}}" />
                                                     <span style="font-size: 15px;">Photo de couverture </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="input-group" >
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="inputGroupFileAddon01">
                                                <fa-icon [icon]="faUpload"></fa-icon>
                                            </span>
                                        </div>
                                        <div class="custom-file">
                                            <input type="file" class="custom-file-input" id="inputGroupFile01"
                                                aria-describedby="inputGroupFileAddon01" lang="fr"
                                                (change)="handleFileInput($event.target.files)">
                                            <label class="custom-file-label" for="inputGroupFile01">Choisissez un
                                                fichier</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="headingFour">
                                <h5 class="mb-0">
                                    <button class="btn btn-link collapsed" data-toggle="collapse"
                                        data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                        Histrorique de Publications
                                    </button>
                                </h5>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour"
                                data-parent="#accordion">
                                <div class="card-body">
                                    <!--***************-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--*****Paramètres*****-->
                <div class="card-body" *ngIf="!Docu">
                    <div id="accordion">
                        <div class="card">
                            <div class="card-header" id="headingTwo">
                                <h5 class="mb-0">
                                    <button class="btn btn-link collapsed" data-toggle="collapse"
                                        data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        Paramètres des chemins URLs
                                    </button>
                                </h5>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                                data-parent="#accordion">
                                <div class="card-body">
                                    <p>Ecriture URL</p>
                                    <div class="input-group mb-3">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon3">{{currentPath}}article/</span>
                                        </div>
                                        <input (keyup)="linkFormat()" class="form-control" type="text" [(ngModel)]="url" name="url"
                                            placeholder="Saisissez URL" id="basic-url"
                                            aria-describedby="basic-addon3"><br />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="headingThree">
                                <h5 class="mb-0">
                                    <button class="btn btn-link collapsed" data-toggle="collapse"
                                        data-target="#collapseThree" aria-expanded="false"
                                        aria-controls="collapseThree">
                                        Balise Méta
                                    </button>
                                </h5>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                                data-parent="#accordion">
                                <div class="card-body">
                                    Français
                                    <input class="article" type="text" [(ngModel)]="metaTitle" name="metaTitle"
                                        placeholder="Titre Méta"><br />
                                    <input class="article" type="text" [(ngModel)]="metaDescription"
                                        name="metaDescription" placeholder="Description"><br />
                                    <input class="article" type="text" [(ngModel)]="metaDetails" name="metaDetails"
                                        placeholder="Détails"><br />
                                    Anglais
                                    <input class="article" type="text" [(ngModel)]="metaTiltleEN" name="metaTiltleEN"
                                        placeholder="Titre Méta"><br />
                                    <input class="article" type="text" [(ngModel)]="metaDescriptionEN"
                                        name="metaDescriptionEN" placeholder="Description"><br />
                                    <input class="article" type="text" [(ngModel)]="metaDetailsEN" name="metaDetailsEN"
                                        placeholder="Détails"><br />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
    #myModal>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header" style="display: block !important; height: auto;">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
                    style="color:white;">&times;</button>
                <h4 style="color:white;" class="modal-title" id="myModalLabel">Prévisualiser</h4>
            </div>
            <div class="modal-body">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="card-header text-center">
                            <ul class="nav nav-tabs card-header-tabs">
                                <li class="nav-item">
                                    <a [href]="" class="nav-link active" *ngIf="isFrench"><img src="assets/images/fr.jpg"
                                            title="Texte en anglais" alt="UK flag" width="30px" height="20px" />
                                        Français</a>
                                    <a [href]="" class="nav-link" (click)="setLangauage(true)" *ngIf="!isFrench"><img
                                            src="assets/images/fr.jpg" title="Texte en anglais" alt="UK flag"
                                            width="30px" height="20px" />
                                        Français</a>
                                </li>
                                <li class="nav-item">
                                    <a [href]="" class="nav-link active" *ngIf="!isFrench"><img src="assets/images/uk.jpg"
                                            title="Texte en anglais" alt="UK flag" width="30px" height="20px" />
                                        Anglais</a>
                                    <a [href]="" class="nav-link" (click)="setLangauage(false)" *ngIf="isFrench"><img
                                            src="assets/images/uk.jpg" title="Texte en anglais" alt="UK flag"
                                            width="30px" height="20px" /> Anglais</a>
                                </li>
                            </ul>
                        </div>
                        <div class="card-body" *ngIf="isFrench">
                            <div id="accordion">
                                <div [innerHTML]="titre  | safeHtml"></div>
                                <span style="font-size: 75%;">Publié par : <b>{{utilisateurCreation}}</b> le :
                                    {{dateCreation | date:'dd/MM/yyyy - HH:mm'}}</span>
                                <div [innerHTML]="resume | safeHtml"></div>
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                        *ngFor="let paragraphe of paragraphes">
                                        <div [innerHTML]="paragraphe.titre | safeHtml"></div>
                                        <div [innerHTML]="paragraphe.body | safeHtml"></div>
                                    </div>
                                </div>
                                <hr />
                                <div>
                                    <p>Tags</p>
                                    <div>
                                        <span *ngFor="let tg of tags"
                                            style="font-weight: 400;font-size: 20px; border-radius: 5px; margin-left: 5px;"
                                            class="badge badge-info"> {{tg.name}} </span> &nbsp;
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="card-body" *ngIf="!isFrench">
                            <div id="accordion">
                                <div [innerHTML]="titreEN  | safeHtml"></div>
                                <span style="font-size: 75%;">Published by : <b>{{utilisateurCreation}}</b> at :
                                    {{dateCreation | date:'dd/MM/yyyy - HH:mm'}}</span>
                                <div [innerHTML]="resumeEN | safeHtml"></div>
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                        *ngFor="let paragraphe of paragraphes">
                                        <div [innerHTML]="paragraphe.titreEN | safeHtml"></div>
                                        <div [innerHTML]="paragraphe.bodyEN | safeHtml"></div>
                                    </div>
                                </div>
                                <hr />
                                <div>
                                    <p>Tags</p>
                                    <div>
                                        <span *ngFor="let tg of tagsEN"
                                            style="font-weight: 400;font-size: 20px; border-radius: 5px; margin-left: 5px;"
                                            class="badge badge-info"> {{tg.name}} </span> &nbsp;
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="item btnClose" data-dismiss="modal">FERMER</button>
                <!--<button (click)="publier()" class="item btnsp" style="margin-left: 3%;">PUBLIER</button>-->
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
    aria-hidden="true" #exampleModalLong>
    <div class="modal-dialog" role="document" style="width: 70% !important; height: 31% !important;">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-left" style="color:white;" id="exampleModalLongTitle">Voulez-vous Sauvegarde
                    cet article ?
                    <br />Si oui merci de renseigner un commentaire
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <textarea class="txtar" id="msg" [(ngModel)]="commentaire" name="commentaire" required="required"
                    cols="50" rows="4"></textarea>
            </div>
            <div class="modal-footer">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <button type="button" class="item btnsp" style="float: left;" data-dismiss="modal">Annuler</button>
                    <button type="button" class="item btnsp" style="float: right;" (click)="publier()"
                        *ngIf="isUpdating == false">Sauvegarder</button>
                    <button type="button" class="item btnsp" style="background-color: #fff;" disabled
                        *ngIf="isUpdating == true">
                        <img alt="Loading"
                            src="data:image/gif;base64,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
                    Nze3P///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAb+wJJwODSMMooChyP4TEIOonRaajA6gGyCY3gIHg8MKUolig6JrBrCBX+/mEZZKMqo71ume0+alyQWd1ptXmBeAhwlIlIiDAh/gWoWFUsLX4YCBlV9RAcAHY+AABsRDYtCHBoLXpoNX3JCGlifoSCJVA4ErYUYZAx3oH5EDYVfBCUGaXcXwkMkhmC9I4IbZM0Oq28PBgOCEc1EGpgPEwp3FiHgQw6FXh8QdxvqQyKrhgsh+fma80IO/wAD/uvnTyAGaAsIijhoCMOHdgKsgdNzCcGEYg809CMw7smeBwtOXcOgbZsDhoU4NbvYbkEUEpe83Grmas+xEg7eZNokUopbAxK73ogkhqjKlwUEOJwSwYEAyaJEYQ3RZRSagJDYoIVppVIKMYxeHHQ5xGvmFBEwrXoR0SVmoZtzGjx1E3HsJQEC0l0jcVDoWDBIJTYT0WACApccFlg0IJhIEAAh+QQJCQAhACwAAAAAHgAeAIUEAgSEgoTEwsTk4uRkZmQkIiT08vTU0tSkoqQUEhTMyszs6uw0NjT8+vy8vrwMCgx8enzc2tysqqwEBgScnpzExsTk5uRsamwsLiz09vQUFhTMzszs7uw8Ojz8/vzc3tysrqz///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG/sCQcDg0gC6MQiYj2EQ4DaJ0GlpAEoBswmBwCByOyidKJXoQ2Kw20/W6K4uy0HNR2x9LsNv9kYckE3ZrXV9fXgIZIR5SHh8Gf4FqEx1LCoZgAo8LfUQLYYkSWRgUC4tCGRYKXppfcUINFV4VjxIQiVQNA5pvZB97s36dbl8DIQ2XxMFDvnphDRx7Dgqmyg2qhQ4GEZhgrspCA3pfEdeHZN8hTHsHsXoK6EMequ4N9fbwQ/b6+/iv+5fS+nloB6bChj0Czn1TZ+jAtj3evoXj9sTQFwUK/cBCCAUbmGLfHg5bxAzTLWWeLoGEVSjKpoz5HFVxg3FIyl3SBmQw5SHDSYAKAoAtaCVFVxWAAqZZa/apCsgpnoZhatBGADZgZRp5LOSBkDgvT8ssiGUxYVWaEeXkIuulazMBA2D68bAgwgGMGRQ4NEBtShAAIfkECQkAEAAsAAAAAB4AHgCEvL685OLk1NLU9PL0zMrM7Ors/Pr8xMbE3NrcxMLE5Obk9Pb0zM7M7O7s/P783N7c////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABf4gJI6jUSAM4QwHgTQGKc+Q8SQAkCTGoOeHR4xGcigOP1xilVMCDgWiyIH4WZe+pvYhhRRwuSTTqVxAHDLHw/y9MhwLArjJ5pIKz4E3RyiYSwoEOnptUSIGSAkHhAFDMzaEYARDD0kJf10ieFYBNXM5nZkiN1oHBg1XKqKHB2A4DVVWhqsQAWE6CIJKPLQiC04AAkhhBL1TgsQGysvGh8vPyguOvQbSy5/Fxg7IQAxJANOiv0kMsT8KxrZaL2QHaKuIwAMGnwl2orGuaKRNeqttYULR05GA0IN3j9bswTFpBJ5LXhgGWPAOToBWBSMCmCUiQKRbCVQY4AaETagZmyuA8ciy48ciKWrq6RgDEsBJIgV0NVmphWADeBfFZOHTSNsJAZPiCEAwT0oIADs=" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="order" tabindex="-1" role="dialog" style="z-index: 1000;" aria-labelledby="ordertitle"
    aria-hidden="true" #order>
    <div class="modal-dialog" role="document" style="width: 60% !important; height: 60% !important;">
        <div class="modal-content">
            <div class="modal-header" style="display: flex !important;">
                <h4 class="modal-title pull-left" style="color:white;" id="ordertitle">Ranger les Paragraphes</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="mat-app-background basic-container">
                    <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
                        <div class="example-box" *ngFor="let ct of paragraphes" cdkDrag>
                            <span *ngIf="ct.titre !== ''" [innerHTML]="ct.titre  | safeHtml"></span>
                            <span *ngIf="ct.titre === ''">Pas de titre</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="text-white btnRest3e" data-dismiss="modal">Fermer</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade bd-example-modal-lg" style="width:500px;" style="font-family: raleway-semibold;"
    id="ModalViewMedia" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true"
    #ModalViewMedia>
    <div class="modal-dialog" role="document" style="width: 60% !important; height: 75% !important;">
        <div class="modal-content">
            <div class="modal-header" style="height: 9% !important;">
                <h5 class="modal-title" style="color:white;" id="exampleModalLabel">Image</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div style="text-align: center;">
                    <img src="{{src}}" alt="{{alt}}" />
                </div>
            </div>
            <div class="modal-footer">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <button class="btnsp" style="float: right;" data-dismiss="modal"> Fermer </button>
                </div>
            </div>
        </div>
    </div>
</div>